/*
 * @Author: madongzhe
 * @Date: 2024-01-15 15:33:03
 * @LastEditors: madongzhe
 * @LastEditTime: 2024-01-16 18:24:17
 * @FilePath: \PWmat\src\helpers\consts.js
 */
export const PWMAT_RESOURCE = "//www.pwmat.com/pwmat-resource/";

export const MODULE_DOWNLOAD =
  "//www.pwmat.com/pwmat-resource/module-download/";

export const PWMAT_VIDEO = "//www.pwmat.com/pwmat-resource/video/";

export const MSTATION_DOWNLOAD =
  "//www.pwmat.com/modulefiles/pwmat-resource/mstation-download/";

// export const Windows_Download = '//www.pwmat.com/pwmat-resource/windows-download/'
// export const LS3DF_Download = '//www.pwmat.com/pwmat-resource/ls3df-download/'
export const Windows_Download =
  "//www.pwmat.com/modulefiles/pwmat-resource/windows-download/";
export const LS3DF_Download =
  "//www.pwmat.com/modulefiles/pwmat-resource/ls3df-download/";
export const PWMLFF_Download =
  "//www.pwmat.com/modulefiles/pwmat-resource/pwmlff-download/";

export const HIGH_THROUGH_PUT_DOWNLOAD =
  "//www.pwmat.com/pwmat-resource/high-through-put/";

export const MCLUSTER_DOWNLOAD =
  "//www.pwmat.com/pwmat-resource/mcluster-download/";
export const PSEDUO_DOWNLOAD =
  "//www.pwmat.com/pwmat-resource/pseduo-download/";

export const UTILITY_DOWNLOAD =
  "//www.pwmat.com/pwmat-resource/utility-download/";

export const COURSE_URL = "http://modulefiles.pwmat.com/";

export const CMS_API_NEWS_IMG = "//www.pwmat.com/upload/";
